export const BASE_URL =
  process.env.REACT_APP_API_BASE_URL || "https://bookepedia-backend.onrender.com";
// Cache buster for deployment synchronization

